import Swiper from "swiper/bundle";

const lightbox = {
  el: null,

  loading: false,

  slider: null,
  thumbs: null,
  thumbs_dom: null,
  slider_dom: null,
  scrolltop: 0,

  init: function () {
    if ($(".gallery-slider, .gallery").length) {
      // Make slider in content
      lightbox.gallery();
      // Load lightbox
      lightbox.load();
      // Add events
      lightbox.events();
    }
  },

  load: function () {
    // Request lightbox
    $.ajax({
      url: ajaxurl,
      data: {
        action: "lightbox",
      },
      type: "POST",
      dataType: "JSON",
      success: function (response) {
        $(".main").append(response);
        lightbox.el = $("#lightbox");
        lightbox.slider_dom = lightbox.el.find(".lightbox-slider");
        lightbox.thumbs_dom = lightbox.el.find(".lightbox-thumbs-slider");
      },
    });
  },

  gallery: function () {
    $(".gallery-slider").each(function (index) {
      let gallery_dom = $(this);

      // Init content slider
      let nav_prev = gallery_dom.find(".swiper-button-prev");
      let nav_next = gallery_dom.find(".swiper-button-next");
      let slider = new Swiper(gallery_dom, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        navigation: {
          prevEl: nav_prev,
          nextEl: nav_next,
        },
        on: {
          init: function () {
            gallery_dom
              .children(".gallery-wrapper")
              .addClass("gallery-wrapper--loaded");
          },
        },
      });

      gallery_dom.data("slider", slider);
    });
  },

  events: function () {
    // Close on X click
    $("body").on("click", ".lightbox-close", function (e) {
      e.preventDefault();
      lightbox.close();
    });

    // Close on ESC key
    $(document).keyup(function (e) {
      if (e.keyCode === 27) {
        lightbox.close();
      }
    });

    // Close if clicked outside of image
    $("body").on("click", ".lightbox-bg", function (e) {
      lightbox.close();
    });

    // Expand image on click
    $("body").on("click", ".gallery img", function () {
      let gallery_dom = $(this).closest(".gallery");
      let item = $(this).closest("[data-item]").data("item");
      lightbox.open(gallery_dom, item);
    });

    // Expand image on Expand click
    $("body").on("click", ".gallery-slider__expand", function (e) {
      e.preventDefault();
      let slider = $(this).closest(".gallery-slider");
      let item = $(".swiper-slide-active", galleryEl).data("item");
      lightbox.open(slider, item);
    });
  },

  close: function () {
    // Destroy slider
    if (lightbox.slider) {
      lightbox.slider.destroy();
    }
    // Remove lightbox
    lightbox.el.removeClass("lightbox--open");
    // Allow scroll
    $("html").removeClass("no-scroll");
    $("html, body").scrollTop(lightbox.scrolltop);
  },

  open: function (slider, item) {
    if (!lightbox.loading) {
      lightbox.loading = true;

      // Disable scroll
      lightbox.scrolltop = $(window).scrollTop();
      $("html").addClass("no-scroll");
      $("html, body").scrollTop(lightbox.scrolltop);
      lightbox.el.addClass("lightbox--loading");

      // Adds slides to slider
      let images = slider.attr("data-ids").split(",").map(Number);
      $.ajax({
        url: ajaxurl,
        data: {
          action: "lightbox_load_images",
          images: images,
        },
        type: "POST",
        success: function (response) {
          if (response.success) {
            lightbox.el.find(".lightbox-wrapper").html(response.data.images);
            lightbox.el
              .find(".lightbox-thumbs-wrapper")
              .html(response.data.thumbs);
            // Load swiper on lightbox
            lightbox.construct(slider, item);
          }
        },
      });
    }
  },

  construct: function (slider, item) {
    // Init slider

    let nav_prev = lightbox.el.find(".swiper-button-prev");
    let nav_next = lightbox.el.find(".swiper-button-next");

    let thumbs = lightbox.el.find(".lightbox-thumbs-container");
    let thumbs_prev = $(".swiper-button-prev", thumbs);
    let thumbs_next = $(".swiper-button-next", thumbs);

    lightbox.thumbs = new Swiper(lightbox.thumbs_dom, {
      initialSlide: item,
      loop: true,
      slidesPerView: 4,
      spaceBetween: 13,
      loopAdditionalSlides: 3,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 2,
      },
      navigation: {
        prevEl: thumbs_prev,
        nextEl: thumbs_next,
      },
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    lightbox.slider = new Swiper(lightbox.slider_dom, {
      initialSlide: item,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        prevEl: nav_prev,
        nextEl: nav_next,
      },
      thumbs: {
        swiper: lightbox.thumbs,
      },
      pagination: {
        el: lightbox.el.find(".lightbox-counter"),
        type: "fraction",
      },
      on: {
        init: function () {
          // Open lightbox
          lightbox.el.removeClass("lightbox--loading");
          lightbox.el.addClass("lightbox--open");
          lightbox.loading = false;
        },
      },
    });

    if (slider.data("slider")) {
      lightbox.slider.on("slideChange", function () {
        // Sync with content
        let slide_to = this.realIndex;
        slider.data("slider").slideToLoop(slide_to);
      });
    }
  },
};

export default lightbox;
